import React from 'react';
import { Globe } from 'lucide-react';
import { getUserTimezone, getUserTimezoneOffset } from '../utils/dateUtils';

/**
 * TimezoneIndicator Component
 * 
 * Displays the user's current timezone to provide context for all displayed times.
 * This helps prevent confusion when users see timestamps (which are shown in their local time).
 * 
 * Example output: "🌍 IST (UTC+5:30)"
 */
export const TimezoneIndicator: React.FC<{ className?: string }> = ({ className = '' }) => {
  const timezone = getUserTimezone();
  const offset = getUserTimezoneOffset();

  return (
    <div className={`flex items-center gap-2 text-sm text-muted-foreground ${className}`}>
      <Globe className="h-4 w-4" />
      <span>
        {timezone} ({offset})
      </span>
    </div>
  );
};

export default TimezoneIndicator;
